.specification-field__container {
  // Empty
}

// Taken from text-input__label
.specification-field__container .specification-dimensions-simple-field__label {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;

  white-space: nowrap;
}

// Taken from text-input__description
.specification-field__container .specification-dimensions-simple-field__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}